/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * OAuth API
 * OAuth API for authentication and authorization
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod"

/**
 * Обменивает код авторизации, полученный от OAuth провайдера,
на JWT токен доступа к Stats API.

 * @summary Обмен кода авторизации на токен доступа
 */
export const ExchangeAuthCodeBody = zod.object({
	client_id: zod.string().describe("Client identifier для OAuth приложения"),
	code: zod
		.string()
		.describe("Authorization code полученный от OAuth провайдера"),
	redirect_uri: zod
		.url()
		.describe("Redirect URI использованный при авторизации"),
})

export const ExchangeAuthCodeResponse = zod.object({
	token: zod.string().describe("JWT токен доступа к Stats API"),
	user: zod.string().describe("Идентификатор пользователя"),
	refreshToken: zod.string().describe("JWT токен обновления для Stats API"),
	error: zod.string().nullish().describe("Error message"),
})

/**
 * Обменивает действующий refresh token на новую пару access_token и refresh_token.
Предыдущие токены становятся недействительными.

 * @summary Обновление пары токенов доступа
 */
export const RefreshTokensBody = zod.object({
	token: zod.string().describe("Действующий access token"),
	refresh: zod.string().describe("Действующий refresh token"),
})

export const RefreshTokensResponse = zod.object({
	access_token: zod.string().describe("Новый access token"),
	refresh_token: zod.string().describe("Новый refresh token"),
})
